import React from 'react'

const SheetBridgeIcon = ({ className, variant = 'teal' }) => {
  const colors = {
    teal: {
      primary: '#14b8a6',
      secondary: '#0d9488',
      accent: '#2dd4bf',
    },
    gray: {
      primary: '#6b7280',
      secondary: '#6b7280',
      accent: '#6b7280',
    },
  }

  const colorScheme = colors[variant] || colors.teal

  return (
    <svg
      className={className}
      viewBox="0 0 2048 2048"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={colorScheme.primary}
        d="M727.25 755.969v369.251h-15.218V755.969z"
      />
      <path
        fill={colorScheme.primary}
        d="M1335.97 768.174v336.966h-15.22V768.174z"
      />
      <path
        fill={colorScheme.secondary}
        d="M1791.99 1200H256.008v-98.66H1791.99z"
      />
      <path fill={colorScheme.primary} d="M919.999 900.418V1104h-16V900.418z" />
      <path fill={colorScheme.primary} d="M1144 900.418V1104h-16V900.418z" />
      <path fill={colorScheme.primary} d="M1712 857.805V1104h-16V857.805z" />
      <path fill={colorScheme.primary} d="M351.999 882.638V1104h-16V882.638z" />
      <path
        fill={colorScheme.accent}
        d="m1772.42 935.86 8.773-30.831c-79.038-30.886-229.945-215.017-265.969-289.703l-10.797-22.386-15.81 19.224c-84.625 102.884-324.186 299.648-464.608 299.648-170.567 0-345.723-213.288-479.087-315.905-75.185 90.795-169.866 266.828-278.097 309.122l8.774 30.831c103.07-38.646 216.416-201.393 265.304-297.634 145.676 108.258 298.877 305.34 482.98 305.34h.251c134.672 0 373.81-174.633 457.637-273.614l15.566-18.378 10.907 21.473c33.854 66.64 193.684 236.384 264.175 262.814z"
      />
      <path
        fill={colorScheme.secondary}
        d="M1536.01 608.302V1456h-64V608.302L1504 592z"
      />
      <path
        fill={colorScheme.secondary}
        d="M576.005 608.302V1456h-64.001V608.302L544.001 592z"
      />
    </svg>
  )
}

export default SheetBridgeIcon
